export class Tab {
    e:any;
    id:any; 
    subproducts:any;
    title:String;
    rooftop:any;
    cIndex:number;
    pIndex:number;
    sIndex:number;
    constructor(e, id, subproducts, title, rooftop, cIndex, pIndex, sIndex)
    {
        this.e = e;
        this.id = id;
        this.subproducts  = subproducts;
        this.title = title;
        this.rooftop = rooftop;
        this.cIndex = cIndex;
        this.pIndex = pIndex;
        this.sIndex = sIndex;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/budget/right-panel/class/tab.ts